$(document).ready(function() {

    handleBannerVisibility();

    $(window).scroll(function() {
        handleBannerVisibility();
    });

    function handleBannerVisibility() {
        var $banner = $(".cms-page__action-btn");
        var $footer = $(".site-footer");

        if (isElementCrossedTarget($banner, $footer)) {
            $banner.removeClass("visible");
        }
        else
        {
            $banner.addClass("visible");
        }
    }

    function isElementCrossedTarget($element, $target) {
        var elementPosition = $element.offset().top;
        var elementHeight = $element.height();

        var targetPosition = $target.offset().top;
        var targetHeight = $target.height();

        if (elementPosition + elementHeight  < targetPosition) {
            return false;
        } else if (elementPosition > targetPosition + targetHeight) {
            return true;
        } else {
            return true;
        }
    }
});

